import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { FtoReportTaskStatus } from '../types';

/**
 * 专利新颖性检查任务状态模型
 * @description 存储专利新颖性检查任务状态
 */
export interface FtoReportTaskStatusModel extends Model<FtoReportTaskStatus>, Disposable {

}

export const FtoReportTaskStatusModel = Symbol.for('FtoReportTaskStatusModel');
